import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { Typography } from '@mui/material';
import './Reviews.css';
import ReviewForm from './ReviewForm';
import Slider from 'react-slick';
const RatingWithFeedback = () => {
  const [reviews, setReviews] = useState([]);
  const reviewTilesRef = useRef([]);
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite looping of slides
    speed: 1000, // Speed of transition (in milliseconds)
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 2, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2500, // Delay between auto slides (in milliseconds)
    arrows: true, // Enable next/previous arrows
    responsive: [
      {
        breakpoint: 1024, // When the screen width is less than 1024px
        settings: {
          slidesToShow: 1, // Show one slide
        },
      },
      {
        breakpoint: 600, // When the screen width is less than 600px
        settings: {
          slidesToShow: 1, // Show one slide
        },
      },
    ],
  };
  

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/reviews'
          
          ,{params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          }}
        
        
        );
        setReviews(response.data);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      }
    };
    fetchReviews();
  }, []);

  const formRef = useRef(null);

  // Observer for form animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (formRef.current) {
      observer.observe(formRef.current);
    }

    return () => {
      if (formRef.current) {
        observer.unobserve(formRef.current);
      }
    };
  }, []);

  return (
    <>
      <div style={{ marginTop: '50px' }}>
        <h1 color='white'>Reviews</h1>
      </div>
      <div ref={formRef} className="forms-container animate-on-scroll">
        <ReviewForm />
      </div>
      <div
  style={{
    position: 'relative',
    width: '100%',
    height: '100vh',
    backgroundImage: `url(${"/Reviewbg.jpg"})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
>
  {/* Overlay container for reviews */}
  <div className="reviewslider-container">
  {reviews.length > 0 ? (
    <Slider {...settings}>
      {reviews.map((review, index) => (
        <div key={index} className="review-tile">
          <div className="review-header">
            {/* Avatar */}
            <img
              src="/Reviewimage.png" // Use a default image if avatar is not provided
              alt={`${review.Name}'s avatar`}
              className="review-avatar"
            />
            {/* Name */}
            <div className="review-text" style={{ fontWeight: "bolder" }}>
              <Typography
                variant="body2"
                style={{ color: "black", fontWeight: "bolder" }}
              >
                {review.Name}
              </Typography>
            </div>
            
          </div>

          <div className="rating" style={{ alignSelf: "center" }}>
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                style={{
                  cursor: "pointer",
                  color: star <= review.rating ? "#e80f17" : "gray",
                }}
              >
                ★
              </span>
            ))}
          </div>

          <div className="review-text">
            <Typography variant="body2" style={{ color: "black" }}>
              {review.feedback}
            </Typography>
          </div>
        </div>
      ))}
    </Slider>
  ) : (
    <Typography variant="body1">No reviews available.</Typography>
  )}
</div>
</div>
    </>
  );
};

export default RatingWithFeedback;
